import React from "react";
import { useDragOver } from "@minoru/react-dnd-treeview";
// import { TypeIcon } from "./TypeIcon";
import PropTypes from "prop-types";
import styled from "styled-components";
import { TypeIcon } from "./TypeIcon";

export const CustomNode = (props) => {
  const { id, droppable } = props.node;
  const indent = props.depth * 24;

  const handleToggle = (e) => {
    e.stopPropagation();
    props.onToggle(props.node.id);
  };

  const dragOverProps = useDragOver(id, props.isOpen, props.onToggle);

  const getTypeByTitle = title => {
    try {
      const split = title.split('.')
      const type = split[split.length - 1]
      return type || "text"
    } catch (error) {
      return 'text'
    }
  }

  return (
    <CustomNodeStyled
      className={`tree-node root`}
      style={{ paddingInlineStart: indent }}
      {...dragOverProps}
    >
      <div
        className={`expandIconWrapper`}
      >
        {props.node.droppable && (
          <div onClick={handleToggle}>
            {/*<ArrowRightIcon />*/}
            <i
              className={
                props.isOpen
                  ? "mdi mdi-chevron-up accor-down-icon ms-auto"
                  : "mdi mdi-chevron-down accor-down-icon ms-auto"
              }
            />
          </div>
        )}
      </div>
      <div>
        <TypeIcon droppable={droppable} fileType={getTypeByTitle(props.node.title)} />
      </div>
      <div className={"labelGridItem"}>
        {/*<Typography variant="body2">{props.node.text}</Typography>*/}
        <span className="me-2">{props.node.title}</span>
        <span className="node-actions">
          <i className="mdi font-size-14 me-1 mdi-delete-outline" onClick={() => props.onDelete(props.node)} title="delete"/>
          {!props.node.droppable && <i className="mdi font-size-14 mdi-download-box-outline" onClick={() => props.onDownload(props.node)}
              title="download" />}
        </span>
      </div>
    </CustomNodeStyled>
  );
};

const CustomNodeStyled = styled.div`
  &.root {
    align-items: center;
    display: grid;
    grid-template-columns: auto auto 1fr auto;
    height: 32px;
    padding-inline-end: 8px;
  }
  
  .node-actions {
    display: none;
    
    i {
      cursor: pointer;
      
      &:hover {
        color: #556ee6
      }
    }
  }
  
  .labelGridItem:hover {
    .node-actions {
      display: initial;
    }
  }
  
  

  .expandIconWrapper {
    align-items: center;
    /*font-size: 0;*/
    cursor: pointer;
    display: flex;
    height: 24px;
    justify-content: center;
    width: 24px;
    transition: transform linear 0.1s;
    transform: rotate(0deg);
  }

  .expandIconWrapper.isOpen {
    transform: rotate(90deg);
  }

  .labelGridItem {
    padding-inline-start: 8px;
  }

`

CustomNode.propTypes = {
  node: PropTypes.any,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  depth: PropTypes.any,
  onDelete: PropTypes.func,
  onDownload: PropTypes.func,
}
